import { observer } from 'mobx-react-lite';
import React, { ReactNode, useEffect, useState } from 'react';
import '../../css/headermenumobile.css';
import menuStore from '../../store/MenuStore'; // store import
import BaseLayout from './BaseLayout';
import HeaderMenuMobile from './HeaderMenuMobile';

interface BBMainProps {
    children: ReactNode; 
}

const BBMobile: React.FC<BBMainProps> = observer(({ children }) => {
  const [hasEntered, setHasEntered] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setHasEntered(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const headerClass =
    !hasEntered
      ? 'header-menu enter'
      : menuStore.isVisible
      ? 'header-menu'
      : 'header-menu hide';

  return (
    <BaseLayout>
      <div className={headerClass} style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: '10',
      }}>
        { menuStore.isAttacted ? <HeaderMenuMobile /> : <></> }
      </div>
      <div style={{ paddingTop: '0px' }}>{children}</div>
    </BaseLayout>
  );
});

export default BBMobile;